import { detect } from 'detect-browser';

function getUAParser(userAgent) {
  return detect(userAgent);
}
function isServer() {
  return typeof window === "undefined" && typeof global !== "undefined";
}
function isIE(userAgent) {
  const detected = getUAParser(userAgent);
  return detected?.name === "ie";
}
function isiOS(userAgent) {
  const detected = getUAParser(userAgent);
  return detected?.os === "iOS";
}
function isAndroid(userAgent) {
  const detected = getUAParser(userAgent);
  return detected?.os === "Android OS";
}
function isSupportedMobileOS(userAgent) {
  return isiOS(userAgent) || isAndroid(userAgent);
}
function isMacOS(userAgent = navigator?.userAgent) {
  return !!userAgent && /macintosh|ios|ipad/gi.test(userAgent);
}
function isFlexNativeMobile(userAgent) {
  return !!userAgent && /flex/gi.test(userAgent);
}

export { isAndroid, isFlexNativeMobile, isIE, isMacOS, isServer, isSupportedMobileOS, isiOS };
//# sourceMappingURL=device.mjs.map
